import { Injectable } from '@angular/core';
import { ContactModel } from '../../../models/contact';
import { GestionTercerosService } from '../../../../dms/modulos/general/componentes/gestion-terceros/gestion-terceros.service';
// import { ContactModel } from '../../../../../../../core/models/contact';


@Injectable()
export class ContactService {
    private _dataContents: Array<ContactModel>;
    arrayTemplates: Array<ContactModel>;
    private _contact: ContactModel;
     _counterContacts: number;
    public levels(): any[] {    return this._dataContents;    }

    constructor(
    private _gestionTercerosService: GestionTercerosService ) {   }


        getDataContents() {
            this._dataContents = this._dataContents;
            return this._dataContents;
        }

        setDataContents(data: any) {
            this._dataContents = data;
            this._gestionTercerosService.customerForm.get('contacts').get('clientContacts').setValue(this._dataContents, { eventEmit: false });
            const datosForm =   this._gestionTercerosService.customerForm.get('contacts').get('clientContacts').value;
        }

        public remove(Contact: any): void {
                const index = this._dataContents.findIndex(({ CONTACTCODE }) => CONTACTCODE === Contact.CONTACTCODE);
                this._dataContents.splice(index, 1);

                this._gestionTercerosService.customerForm.get('contacts').get('clientContacts').setValue(this._dataContents);
                const datosForm =   this._gestionTercerosService.customerForm.get('contacts').get('clientContacts').value;

        }

        public save(Contact: any, isNew: boolean, arrayTemplates: any): void {
                this._counterContacts = arrayTemplates.length;

                this._dataContents = arrayTemplates;

                this._contact = new ContactModel();

                this._contact.CONTACTCODE = Contact.CONTACTCODE.value;
                this._contact.CUSTOMERCODE = Contact.CUSTOMERCODE.value;
                this._contact.Name1 = Contact.Name1.value;
                this._contact.Name2 = Contact.Name2.value;
                this._contact.LastName1 = Contact.LastName1.value;
                this._contact.LastName2 = Contact.LastName2.value;
                this._contact.Phone = Contact.Phone.value;
                this._contact.Email = Contact.Email.value;
                this._contact.Webpage = Contact.Webpage.value;
                this._contact.Notes = Contact.Notes.value;
                this._contact.Post = Contact.Post.value;
                this._contact.Fax = Contact.Fax.value;
                this._contact.newContact = Contact.newContact.value;


                if (isNew) {
                this._dataContents.splice(0, 0,  this._contact);
                } else {
                    this._dataContents.map(item => {
                        if (item.CONTACTCODE === this._contact.CONTACTCODE) {
                            Object.assign(item, this._contact);
                        }
                    });
                }
        }
}
